import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CoreService } from 'src/app/core/services/core.service';

import { StorageService } from 'src/app/core/storage/storage.service';
import { LoanOptions } from 'src/app/shared/model/loanRequest.enum';
import { OrderRequest } from 'src/app/shared/model/order.model';
import { User } from 'src/app/shared/model/user.model';
import { OrderModalComponent } from '../leasing-endowment-request/order-modal/order-modal.component';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import i18next from 'i18next';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-loan-request',
  templateUrl: './loan-request.component.html',
  styleUrls: ['./loan-request.component.scss'],
  imports: [CommonModule, I18NextModule, RouterModule, StepperComponent]
})
export class LoanRequestComponent implements OnInit, AfterViewInit {
  user!: User;
  requestType = '';
  requestTypeEnum = RequestType;
  modalContent?: NgbModalRef;
  spinner = false;
  extraEmail = '';
  extraPhone = '';
  carConfigurator = true;
  requestObj!: OrderRequest;
  moreThanOneVehicle = false;

  steps = new Map<string, boolean>();
  approvers = false;
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    public coreService: CoreService,
    public router: Router,
    public modalConfig: NgbModal,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.requestType = this.requestTypeEnum.loan;
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('request-info', true);
    this.steps.set('approvers', true);
    this.steps.set('car-config', true);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }

  submitRequest(requestInfoObj: {
    form: FormGroup<any>;
    moreThanOneVehicle: boolean;
    requestObj: OrderRequest;
  }): void {
    this.loading = true;
    const moreThanOneVehicle = requestInfoObj.moreThanOneVehicle;
    const form = requestInfoObj.form;

    const phone = this.extraPhone.trim();
    const email = this.extraEmail.trim();

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    requestInfoObj.requestObj.contactInfoDataDTO = contactInfoDataDTO;

    this.coreService.newOrder(requestInfoObj.requestObj).subscribe({
      next: () => {
        this.loading = false;
        this.openModal(moreThanOneVehicle, form, true);
      },
      error: () => {
        this.loading = false;
        this.openModal(moreThanOneVehicle, form, false);
      }
    });
  }

  openModal(moreThanOneVehicle: boolean, form: FormGroup, resp: boolean) {
    this.modalContent = this.modalConfig.open(OrderModalComponent, {
      windowClass: 'order-modal',
      centered: true,
      backdrop: 'static'
    });
    this.modalContent.componentInstance.modalData = resp;
    this.modalContent.componentInstance.spinnerModalEmitter?.subscribe(
      (resp: boolean) => {
        this.spinner = resp;
      }
    );
    this.modalContent.componentInstance.closeModalEmitter.subscribe(() => {
      this.redirectTo(moreThanOneVehicle, form);
    });
  }

  redirectTo(moreThanOneVehicle: boolean, form: FormGroup) {
    if (moreThanOneVehicle && form.value.moreThanOneVehicle) {
      location.reload();
    } else if (
      form.getRawValue().loanType === LoanOptions.LD &&
      form.value.moreThanOneVehicle
    ) {
      this.router.navigate([], {
        queryParams: { moreThanOneVehicle: true }
      });
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

  onDataChange(data: { email: string; phone: string }): void {
    this.extraEmail = data.email;
    this.extraPhone = data.phone;
  }

  generateRequestObject(newRequestData: any) {
    const orderInfo = {
      requestType: this.requestTypeEnum.loan,
      comments: newRequestData.comments,
      controllerUserId: newRequestData.controller?.id || null,
      delegatedApproverUserId: newRequestData.authorizer?.id
    };
    const phone = newRequestData.extraPhone.trim();
    const email = newRequestData.extraEmail.trim();

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }
    this.requestObj = {
      orderInfo: { ...orderInfo },
      loanData: { ...newRequestData.loanData },
      contactInfoDataDTO: { ...contactInfoDataDTO }
    };
  }

  openConfirmationModal() {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.coreService.newOrder(this.requestObj).subscribe({
        next: () => {
          if (
            this.requestObj.loanData?.loanOrderType !== 'LONG_DURATION' ||
            (this.requestObj.loanData?.loanOrderType === 'LONG_DURATION' &&
              !this.moreThanOneVehicle)
          ) {
            this.dialog.open(FeedbackModalComponent, {
              data: {
                text: i18next.t('newRequestOk'),
                redirect: true,
                list: true,
                theme: 'ligth'
              },
              disableClose: true
            });
          } else if (
            this.requestObj.loanData?.loanOrderType === 'LONG_DURATION' &&
            this.moreThanOneVehicle
          ) {
            this.dialog.open(FeedbackModalComponent, {
              data: {
                text: i18next.t('newRequestOk'),
                close: true,
                theme: 'ligth'
              },
              disableClose: true
            });
          }
        },
        error: () => {
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.moreThanOneVehicle = newRequestData.moreThanOneVehicle;
    this.generateRequestObject(newRequestData);
    this.openConfirmationModal();
  }
}
